export default __webpack_public_path__ + "static/media/frbanner.e8dfee66.jpg";